import { Calendar } from '@fullcalendar/core';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import interactionPlugin from '@fullcalendar/interaction';
console.log("Importing Calendar: ", Calendar);

import '@fullcalendar/common/main.css';
import './packs/stripe_checkout';
import Rails from '@rails/ujs'
Rails.start()

function formatDateToISO(date) {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

function fetchBookingPrice(arrivalDate, departureDate, guests = 2) {
  const params = new URLSearchParams({
    arrival_date: formatDateToISO(arrivalDate),
    departure_date: formatDateToISO(departureDate),
    number_of_guests: guests
  });

  fetch(`/api/bookings/price?${params.toString()}`)
    .then(response => response.json())
    .then(data => {
      const priceDisplay = document.getElementById('booking-price');
      if (data.price && priceDisplay) {
        const formattedPrice = parseFloat(data.price).toFixed(2);
        priceDisplay.value = `${formattedPrice}`;
      } else {
        console.error('Price fetch failed', data.error || 'Unknown error')
      }
    })
    .catch(error => {
      console.error('Fetch error', error);
    });
}

function showStayLengthError(minNights) {
  const messageContainer = document.getElementById('calendar-message');
  if (!messageContainer) return;

  messageContainer.innerHTML = `Minimum stay is ${minNights} nights. Please select a longer stay.`;
  messageContainer.classList.remove('hidden');

  setTimeout(() => {
    messageContainer.classList.add('hidden')
  }, 4000);
}

document.addEventListener("DOMContentLoaded", function () {

  const calendarEl = document.getElementById("calendar");
  const minimumStay = parseInt(calendarEl.dataset.minimum_stay, 10);
  const guestsInput = document.getElementById("booking_number_of_guests");
  const today = new Date();
  const oneYearFromNow = new Date();
  let arrivalInput = document.getElementById('booking_arrival_date');
  let departureInput = document.getElementById('booking_departure_date');

  oneYearFromNow.setFullYear(today.getFullYear() + 1);

  let selectedDates = {
      arrival_date: null,
      departure_date: null
    };

  if (calendarEl) {
    const calendar = new Calendar(calendarEl, {
      plugins: [dayGridPlugin, interactionPlugin],
      initialView: "dayGridMonth",
      selectable: true,
      timeZone: 'Europe/Zurich',
      longPressDelay: 100,
      selectLongPressDelay: 100,
      eventLongPressDelay: 100,
      validRange: {
        start: today.toISOString().split('T')[0],
        end: oneYearFromNow.toISOString().split('T')[0]
      },
      events: 'api/bookings/booked_dates',
      eventSources: [
        {
          url: 'api/bookings/booked_dates',
          method: 'GET',
          failure: () => {
            alert('There was an error to fetch bookings');
          }
        }
      ],
      selectAllow: function(selectionInfo) {
        const today = new Date();
        today.setHours(0, 0, 0, 0);

        if (selectionInfo.start < today) {
          return false;
        }

        const events = calendar.getEvents();

        for (let event of events) {
          if (event.display === 'background') {
            if (
              selectionInfo.start < event.end &&
              selectionInfo.end > event.start
            ) {
              return false;
            }
          }
        }

        return true;
      },
      select: function(info) {
        if (!selectedDates.arrival_date) {
            selectedDates.arrival_date = new Date(info.start);
            arrivalInput.value = formatDateToISO(selectedDates.arrival_date);
            console.log('Arrival input: ', arrivalInput.value)
        } else if (!selectedDates.departure_date) {
            const adjustedEnd = new Date(info.end)
            adjustedEnd.setDate(adjustedEnd.getDate() - 1);

            const stayLength = (adjustedEnd - selectedDates.arrival_date) / (1000 * 60 * 60 * 24);
            const minimumStay = parseInt(calendarEl.dataset.minimumStay, 10);
            console.log("Minimum stay: ", minimumStay);
            console.log("Stay Length: ", stayLength);

            if (stayLength < minimumStay) {
              showStayLengthError(minimumStay);
              return;
            }

            selectedDates.departure_date = adjustedEnd;
            departureInput.value = formatDateToISO(adjustedEnd);
            console.log('Departure input: ', departureInput.value)

            const displayEnd = new Date(adjustedEnd);
            displayEnd.setDate(displayEnd.getDate() + 1);

            calendar.addEvent({
                title: 'Your Booking',
                start: selectedDates.arrival_date,
                end: displayEnd,
                color: '#3182ce',
                allDay: true,
                extendedProps: { preview: true }
            });
            calendar.unselect();

            const numberOfGuests = parseInt(guestsInput?.value, 10) || 2;
            fetchBookingPrice(selectedDates.arrival_date, selectedDates.departure_date, numberOfGuests);
        } else {
          selectedDates.arrival_date = null;
          selectedDates.departure_date = null;
          arrivalInput.value = '';
          departureInput.value = '';
          calendar.getEvents().forEach(event => {
            event.remove();
          });
          console.log('Resetting price display')

          const priceDisplay = document.getElementById('booking-price')
          if (priceDisplay) {
            priceDisplay.value = '';
          }

          console.log('Calendar reset, ready for new booking dates')
        }
      }
    });

    calendar.render();
  }

  guestsInput?.addEventListener('input', () => {
    let guests = parseInt(guestsInput.value, 10);
    if (!isNaN(guests) && selectedDates.arrival_date && selectedDates.departure_date) {
      fetchBookingPrice(selectedDates.arrival_date, selectedDates.departure_date, guests);
      console.log(`Updating based a new number of guests: ${guests}`)
    }
  });

  const anchor = window.location.hash;
  if (anchor === '#calendar') {
    const calendarSection = document.querySelector(anchor);
    if (calendarSection) {
      calendarSection.scrollIntoView({ behavior: 'smooth' });
    }
  }
});